import React, { VFC } from 'react';
import { Theme, useTheme } from '@material-ui/core/styles';
import styled from 'styled-components';

const DescriptionText = styled.div<{ theme: Theme }>`
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  white-space: pre-wrap;
  width: 100%;
  line-height: 1.8;
  margin: ${({ theme }) => theme.spacing(2, 'auto', 2)};
  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 45%;
    margin: ${({ theme }) => theme.spacing(0, 'auto', 4)};
  }
`;

interface Props {}

const Description: VFC<Props> = () => {
  const theme = useTheme();

  return (
    <>
      <DescriptionText theme={theme}>
        「人とみどりが輝くまち とよの」をスローガンに地域創生に取り組む、大阪府
        豊能町の困りごとをおてつたびを通じて解決しよう！
      </DescriptionText>
    </>
  );
};

export default Description;
